import { type ToggleButtonGroupProps } from "@mui/material";
import { withStyles } from "@mui/styles";
import {
  C_ON_PRIMARY_CONTAINER,
  C_ON_SURFACE,
  C_OUTLINE_VARIANT,
  C_PRIMARY_CONTAINER,
} from "~/common/components/icon/Colors";

import { ToggleButton as MuiToggleButton, ToggleButtonGroup as MuiToggleButtonGroup } from "@mui/material";

export const ToggleButton = withStyles({
  root: {
    background: "white",
    color: C_ON_SURFACE,
    borderColor: C_OUTLINE_VARIANT,
    height: "40px",
    textTransform: "none",
    letterSpacing: "unset",
  },
  selected: {
    fontWeight: "bold",
    background: `${C_PRIMARY_CONTAINER} !important`,
    color: `${C_ON_PRIMARY_CONTAINER} !important`,
  },
})(MuiToggleButton);
export const ToggleButtonGroup = withStyles({
  grouped: {
    flex: (props: ToggleButtonGroupProps & { fullWidth?: boolean }) => (props.fullWidth ? 1 : undefined),
  },
  groupedHorizontal: {
    "&:not(:first-child)": {
      marginLeft: 0,
    },
  },
})(MuiToggleButtonGroup);
